$(document).ready(function() {

	$('.collapse').on('show.bs.collapse', function() {

		$(this).closest('.panel').find('.accordion-arrow').removeClass('fa-angle-down').addClass('fa-angle-up');

	});

	$('.collapse').on('hide.bs.collapse', function() {

		$(this).closest('.panel').find('.accordion-arrow').removeClass('fa-angle-up').addClass('fa-angle-down');

	});

})

// $(".click-job-lightbox").click(function() {

	// $('.modal-jobs-form').addClass('active');
	// var job_data = $(this).attr('data-job-info');
	// var job_title = $(this).attr('data-job-title');
	// var job_id = $(this).attr('data-job-id'); 

	// $('.form-title').text(job_title);
	// $('.form-title-id').text(job_id);
	// $('[name*="db[5117]"]').val(job_data);

// });

// $("body").on("click", ".black-shutter, .click_close", function() {

// 	$('.modal-jobs-form').removeClass('active');

// });


// upload files

$(function() {
	$(".fileuplaodcv").AjaxFileUpload({
		onChange: function(filename) {
			$(this).closest('.fileupload').find(".btn-file").addClass("uploading");
		},
		onComplete: function(filename, response) {

			if (response == 'FAILED') { // לא תמיד צריך את זה
				$(this).closest('.fileupload').find(".fileuplaodcvupdate").val(response)
				$(this).closest('.fileupload').find(".txt_up").text(response);
				$(this).closest('.fileupload').find(".btn-file").removeClass("uploading");

			} else {
				$(this).closest('.fileupload').find(".fileuplaodcvupdate").val(response)
				$(this).closest('.fileupload').find(".txt_up").text(filename);
				$(this).closest('.fileupload').find(".btn-file").removeClass("uploading");
			}

		}
	});
});
